export const INCREMENET = "product/increment";
export const DECREMENT = "product/decrement";
